/* Sell To Us page: desktop-locked accordions, drawer close on link click. */
(function () {
  var mq = window.matchMedia('(min-width: 900px)');

  function setupAccordions(root) {
    root.querySelectorAll('[data-spd-sell-accordion]').forEach(function (group) {
      if (group.dataset.spdSellReady) return;
      group.dataset.spdSellReady = '1';
      var items = group.querySelectorAll(':scope details');
      function apply() {
        items.forEach(function (d, i) {
          if (mq.matches) {
            d.open = true;
            d.dataset.spdSellLocked = '1';
          } else {
            delete d.dataset.spdSellLocked;
            d.open = i === 0 && group.hasAttribute('data-spd-sell-open-first');
          }
        });
      }
      apply();
      mq.addEventListener('change', apply);
      group.addEventListener('click', function (e) {
        var s = e.target.closest('summary');
        if (s && s.parentElement.dataset.spdSellLocked) e.preventDefault();
      });
    });
  }

  function setupDrawers(root) {
    root.querySelectorAll('[data-spd-sell-drawer]').forEach(function (d) {
      if (d.dataset.spdSellReady) return;
      d.dataset.spdSellReady = '1';
      d.addEventListener('click', function (e) {
        if (e.target.closest('a') && typeof d.hidePopover === 'function' && d.matches(':popover-open')) d.hidePopover();
      });
    });
  }

  function setupGalleries(root) {
    // Desktop: selection, hover and prev/next are pure CSS. Phones: a snap carousel, so this keeps
    // the radio (and its dot) in step with the slide in view, and scrolls to a slide when a dot or
    // arrow picks one.
    root.querySelectorAll('[data-spd-sell-gallery]').forEach(function (gallery) {
      if (gallery.dataset.spdSellReady) return;
      gallery.dataset.spdSellReady = '1';
      var track = gallery.querySelector('.spd-sell-gallery__track');
      var items = [].slice.call(track.querySelectorAll('.spd-sell-gallery__item'));
      var desktop = window.matchMedia('(min-width: 1000px)');
      var reduce = window.matchMedia('(prefers-reduced-motion: reduce)');
      var settling = null;
      var timer = null;

      function slideInView() {
        var edge = track.getBoundingClientRect().left + parseFloat(getComputedStyle(track).paddingLeft);
        var best = null, gap = Infinity;
        items.forEach(function (item) {
          var d = Math.abs(item.getBoundingClientRect().left - edge);
          if (d < gap) { gap = d; best = item; }
        });
        return best;
      }
      function syncFromScroll() {
        if (desktop.matches || settling) return;
        var item = slideInView();
        var pick = item && item.querySelector('.spd-sell-gallery__pick');
        if (pick && !pick.checked) pick.checked = true;
      }
      function settled() { settling = null; syncFromScroll(); }

      gallery.addEventListener('change', function (e) {
        var item = e.target.closest('.spd-sell-gallery__item');
        if (!item || desktop.matches) return;
        settling = item;
        clearTimeout(timer);
        timer = setTimeout(settled, reduce.matches ? 50 : 800);
        item.scrollIntoView({ inline: 'start', block: 'nearest', behavior: reduce.matches ? 'instant' : 'smooth' });
      });
      if ('onscrollend' in window) track.addEventListener('scrollend', settled);
      track.addEventListener('scroll', function () {
        if (settling) return;
        clearTimeout(timer);
        timer = setTimeout(syncFromScroll, 80);
      }, { passive: true });
      desktop.addEventListener('change', syncFromScroll);
      syncFromScroll();
    });
  }

  // Videos. Rules that hold everywhere on the page: nothing plays with sound until play is pressed,
  // and starting one video stops every other one.
  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  function noop() {}
  function previewsOn(card) {
    var sec = card.closest('[data-spd-sell-videos]');
    return !!sec && sec.dataset.autoplay === 'true' && !reduceMotion;
  }
  function player(card) { return card.querySelector('video.spd-sell-video__player'); }
  // Back to the resting card: thumbnail (or silent preview), copy and play button.
  function stopCard(card) {
    var v = player(card);
    card.classList.remove('is-playing', 'is-loading');
    var yt = card.querySelector('iframe.spd-sell-video__yt');
    if (yt) {
      var ytBtn = card.querySelector('[data-spd-sell-yt]');
      var hadFocus = document.activeElement === yt;
      yt.remove();
      if (ytBtn) {
        ytBtn.hidden = false;
        if (hadFocus) ytBtn.focus({ preventScroll: true });
      }
    }
    if (!v) return;
    v.pause();
    v.controls = false;
    try { v.currentTime = 0; } catch (e) {}
    if (previewsOn(card)) {
      v.muted = true;
      v.loop = true;
      if (card.dataset.spdSellInView === '1') v.play().catch(noop);
    }
  }
  function playCard(card) {
    var v = player(card);
    var sec = card.closest('[data-spd-sell-videos]');
    if (!v || !sec) return;
    silenceOthers(v);
    v.loop = false;
    v.muted = false;
    v.controls = sec.dataset.controls !== 'false';
    try { v.currentTime = 0; } catch (e) {}
    card.classList.add('is-playing');
    var started = v.play();
    if (started && started.catch) started.catch(function () { stopCard(card); });
    if (v.controls) v.focus({ preventScroll: true });
    document.dispatchEvent(new CustomEvent('spd-sell:video-play', { detail: { title: (card.querySelector('.spd-sell-video__title') || {}).textContent || '', el: card } }));
  }
  // YouTube cards: nothing from YouTube loads until play is pressed. The iframe goes in synchronously
  // inside the click, so the press reaches the player through allow="autoplay" (Chrome, Firefox).
  // Engines that refuse autoplay in a frame created after the click (Safari) get a second push: the
  // playVideo command once the player has loaded. The card keeps its poster and a spinner on top until
  // the player is playing or buffering, asks for a press of its own, or 2.5 s after it loaded, so
  // nobody stares at a black box and presses again. The player then takes focus.
  var YT_ORIGIN = 'https://www.youtube-nocookie.com';
  function playYouTube(btn) {
    var card = btn.closest('[data-spd-sell-card]');
    var id = btn.getAttribute('data-spd-sell-yt') || '';
    var media = card && card.querySelector('.spd-sell-video__media');
    if (!media || !/^[A-Za-z0-9_-]{11}$/.test(id)) return;
    silenceOthers(null);
    var start = parseInt(btn.getAttribute('data-spd-sell-yt-start'), 10);
    var title = ((card.querySelector('.spd-sell-video__title') || {}).textContent || '').trim();
    var frame = document.createElement('iframe');
    frame.className = 'spd-sell-video__yt';
    frame.title = title || 'YouTube video';
    frame.allow = 'autoplay; encrypted-media; picture-in-picture';
    frame.setAttribute('allowfullscreen', '');
    frame.src = YT_ORIGIN + '/embed/' + id + '?autoplay=1&playsinline=1&rel=0&enablejsapi=1&origin=' + encodeURIComponent(location.origin) + (start > 0 ? '&start=' + start : '');
    var hello = 0;
    var fallback = 0;
    function send(msg) {
      if (frame.contentWindow) frame.contentWindow.postMessage(JSON.stringify(msg), YT_ORIGIN);
    }
    function play() { send({ event: 'command', func: 'playVideo', args: '' }); }
    function reveal() {
      clearInterval(hello);
      clearTimeout(fallback);
      window.removeEventListener('message', onMessage);
      card.classList.remove('is-loading');
    }
    function onMessage(e) {
      if (!frame.isConnected) { reveal(); return; }
      if (e.source !== frame.contentWindow || e.origin !== YT_ORIGIN) return;
      var d;
      try { d = typeof e.data === 'string' ? JSON.parse(e.data) : e.data; } catch (err) { return; }
      if (!d || !d.event) return;
      clearInterval(hello);
      if (d.event === 'onReady') play();
      var state = d.info && typeof d.info.playerState === 'number' ? d.info.playerState : (d.event === 'onStateChange' ? d.info : null);
      if (state === 1 || state === 3 || d.event === 'onAutoplayBlocked') reveal();
    }
    window.addEventListener('message', onMessage);
    fallback = setTimeout(reveal, 8000);
    frame.addEventListener('load', function () {
      // Subscribe to the player's state (repeated until it answers), and push play once.
      send({ event: 'listening', id: id, channel: 'widget' });
      play();
      var tries = 0;
      hello = setInterval(function () {
        if (!frame.isConnected || ++tries > 20) { clearInterval(hello); return; }
        send({ event: 'listening', id: id, channel: 'widget' });
      }, 250);
      clearTimeout(fallback);
      fallback = setTimeout(reveal, 2500);
      // Focus on the iframe element alone does not reach the player's own controls, so hand focus
      // to its document (if the visitor has not moved on).
      if (document.activeElement === frame) { try { frame.contentWindow.focus(); } catch (err) {} }
    }, { once: true });
    card.classList.add('is-playing', 'is-loading');
    media.appendChild(frame);
    btn.hidden = true;
    frame.focus({ preventScroll: true });
    document.dispatchEvent(new CustomEvent('spd-sell:video-play', { detail: { title: title, el: card } }));
  }
  // A YouTube player in fullscreen must not be torn down by the off-screen check below.
  function ytFullscreen(card) {
    var fs = document.fullscreenElement || document.webkitFullscreenElement;
    return !!fs && fs.tagName === 'IFRAME' && card.contains(fs);
  }
  // Stops every other audible video in the Sell To Us sections, popups included.
  function silenceOthers(keep) {
    document.querySelectorAll('.spd-sell-video.is-playing').forEach(function (card) {
      if (!keep || player(card) !== keep) stopCard(card);
    });
    document.querySelectorAll('[data-spd-sell-video]').forEach(function (modal) {
      var v = modal.querySelector('video');
      if (!v || v === keep) return;
      if (modal.matches(':popover-open') && typeof modal.hidePopover === 'function') modal.hidePopover();
      else v.pause();
    });
  }
  function setupVideos(root) {
    if (!document.documentElement.dataset.spdSellVideoGuard) {
      document.documentElement.dataset.spdSellVideoGuard = '1';
      // Media events do not bubble, so listen in the capture phase. Covers the native controls too.
      document.addEventListener('play', function (e) {
        var v = e.target;
        if (!v || v.tagName !== 'VIDEO' || v.muted || !v.closest('.spd-sell')) return;
        silenceOthers(v);
      }, true);
      document.addEventListener('ended', function (e) {
        var card = e.target.closest && e.target.closest('.spd-sell-video.is-playing');
        if (card) stopCard(card);
      }, true);
      document.addEventListener('click', function (e) {
        var btn = e.target.closest('[data-spd-sell-play]');
        if (btn) { playCard(btn.closest('[data-spd-sell-card]')); return; }
        var ytBtn = e.target.closest('[data-spd-sell-yt]');
        if (ytBtn) { playYouTube(ytBtn); return; }
        // With the controls switched off, a click on the playing video pauses and resumes it.
        var v = e.target.closest('.spd-sell-video.is-playing video');
        if (v && !v.controls) { if (v.paused) v.play().catch(noop); else v.pause(); }
      });
    }

    root.querySelectorAll('video.spd-sell-video__player, video.spd-sell-story__bg').forEach(function (v) {
      if (reduceMotion) { v.pause(); v.removeAttribute('autoplay'); }
    });

    // A card that leaves the screen stops: swiping the row on a phone, the arrows on desktop, or
    // scrolling the page. Silent previews only run while their card is on screen.
    var watcher = 'IntersectionObserver' in window ? new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        var card = en.target;
        var v = player(card);
        var inView = en.intersectionRatio >= 0.5;
        card.dataset.spdSellInView = inView ? '1' : '';
        if (card.classList.contains('is-playing')) { if (!inView && !ytFullscreen(card)) stopCard(card); return; }
        if (!v) return;
        if (!previewsOn(card)) return;
        if (inView) v.play().catch(noop); else v.pause();
      });
    }, { threshold: [0, 0.5, 1] }) : null;

    root.querySelectorAll('[data-spd-sell-videos]').forEach(function (sec) {
      if (sec.dataset.spdSellReady) return;
      sec.dataset.spdSellReady = '1';
      var track = sec.querySelector('.spd-sell-videos__track');
      var prev = sec.querySelector('[data-spd-sell-videos-prev]');
      var next = sec.querySelector('[data-spd-sell-videos-next]');
      var dots = sec.querySelectorAll('.spd-sell-videos__hint i');
      if (!track) return;
      if (watcher) sec.querySelectorAll('[data-spd-sell-card]').forEach(function (card) { watcher.observe(card); });
      function pitch() {
        var first = track.children[0];
        return first ? first.getBoundingClientRect().width + (parseFloat(getComputedStyle(track).columnGap) || 0) : 306;
      }
      function sync() {
        var max = track.scrollWidth - track.clientWidth;
        var over = max > 1;
        sec.classList.toggle('has-overflow', over);
        // The row scrolls sideways, so it has to be reachable from the keyboard when it overflows.
        track.tabIndex = over ? 0 : -1;
        if (prev) prev.disabled = track.scrollLeft <= 1;
        if (next) next.disabled = track.scrollLeft >= max - 1;
        var at = Math.min(dots.length - 1, Math.round(track.scrollLeft / pitch()));
        if (track.scrollLeft >= max - 1 && over) at = dots.length - 1;
        dots.forEach(function (d, i) { d.classList.toggle('is-active', i === at); });
      }
      function page(dir) {
        var step = pitch();
        var visible = Math.max(1, Math.floor((track.clientWidth - parseFloat(getComputedStyle(track).paddingLeft)) / step));
        track.scrollBy({ left: dir * step * visible, behavior: reduceMotion ? 'auto' : 'smooth' });
      }
      if (prev) prev.addEventListener('click', function () { page(-1); });
      if (next) next.addEventListener('click', function () { page(1); });
      var ticking = false;
      track.addEventListener('scroll', function () {
        if (ticking) return;
        ticking = true;
        requestAnimationFrame(function () { ticking = false; sync(); });
      }, { passive: true });
      window.addEventListener('resize', sync);
      sync();
    });

    root.querySelectorAll('[data-spd-sell-video]').forEach(function (modal) {
      if (modal.dataset.spdSellReady) return;
      modal.dataset.spdSellReady = '1';
      modal.addEventListener('toggle', function (e) {
        var video = modal.querySelector('video');
        if (!video) return;
        var previews = document.querySelectorAll('video.spd-sell-video__player, video.spd-sell-story__bg');
        if (e.newState === 'open') {
          silenceOthers(video);
          previews.forEach(function (p) { if (p.muted) p.pause(); });
          video.muted = false;
          video.play().catch(noop);
        } else {
          video.pause();
          try { video.currentTime = 0; } catch (err) {}
          if (!reduceMotion) previews.forEach(function (p) {
            var card = p.closest('[data-spd-sell-card]');
            if (p.muted && p.hasAttribute('autoplay') && (!card || card.dataset.spdSellInView === '1')) p.play().catch(noop);
          });
        }
      });
    });
  }


  function mirrorForms(root) {
    var targets = root.querySelectorAll('[data-spd-sell-form-mirror] .pxFormGenerator');
    if (!targets.length) return;
    var tries = 0;
    function attempt() {
      var pending = false;
      targets.forEach(function (target) {
        if (target.querySelector('iframe')) return;
        var source = null;
        document.querySelectorAll('.pxFormGenerator iframe').forEach(function (f) {
          if (!source && f.parentElement !== target && f.parentElement.id === target.id) source = f;
        });
        if (!source) { pending = true; return; }
        var clone = source.cloneNode(false);
        clone.id = source.id + '-mirror';
        if (source.title) clone.title = source.title + ' (bottom of page)';
        clone.style.height = source.style.height;
        target.appendChild(clone);
        new MutationObserver(function () { clone.style.height = source.style.height; })
          .observe(source, { attributes: true, attributeFilter: ['style'] });
      });
      if (pending && tries++ < 40) setTimeout(attempt, 500);
    }
    attempt();
  }


  function setupRail(root) {
    var nav = root.querySelector ? root.querySelector('.spd-sell-hero__nav') : null;
    if (!nav || nav.dataset.spdSellSpy) return;
    nav.dataset.spdSellSpy = '1';
    var links = [].slice.call(nav.querySelectorAll('.spd-sell-hero__nav-link'));
    var targets = links.map(function (a) { var h = a.getAttribute('href') || ''; return h.charAt(0) === '#' ? document.getElementById(h.slice(1)) : null; });
    if (!('IntersectionObserver' in window)) return;
    var visible = {};
    function paint() {
      var best = null, bestTop = Infinity;
      targets.forEach(function (t, i) {
        if (!t || !visible[i]) return;
        var top = Math.abs(t.getBoundingClientRect().top - 140);
        if (top < bestTop) { bestTop = top; best = i; }
      });
      if (best === null) {
        // Nothing in the reading band: above the first target means the top of the page.
        var first = targets.filter(Boolean)[0];
        if (!first || first.getBoundingClientRect().top < window.innerHeight * 0.5) return;
        best = targets.indexOf(first);
      }
      links.forEach(function (a, i) { a.classList.toggle('is-active', i === best); });
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) { var i = targets.indexOf(e.target); if (i > -1) visible[i] = e.isIntersecting; });
      paint();
    }, { rootMargin: '-30% 0px -50% 0px', threshold: 0 });
    targets.forEach(function (t) { if (t) io.observe(t); });
    var ticking = false;
    window.addEventListener('scroll', function () { if (ticking) return; ticking = true; requestAnimationFrame(function () { ticking = false; paint(); }); }, { passive: true });
    var footer = document.querySelector('[id^="shopify-section"][id*="footer"], .site-footer');
    if (footer) {
      new IntersectionObserver(function (entries) { nav.classList.toggle('is-hidden', entries[0].isIntersecting); }, { threshold: 0.05 }).observe(footer);
    }
  }

  // Clicks and views on the Sell To Us page, sent through window.spdTrack (snippets/spd-lead-tracking).
  function track(name, params) { if (typeof window.spdTrack === 'function') window.spdTrack(name, params); }
  function where(el) {
    var sec = el.closest('.spd-sell-section, .spd-sell');
    if (!sec) return '';
    if (sec.id) return sec.id;
    var cls = [].slice.call(sec.classList).filter(function (c) { return /^spd-sell-[a-z]+$/.test(c) && !/^spd-sell-(section|dark)$/.test(c); });
    return cls[0] ? cls[0].replace('spd-sell-', '') : '';
  }
  function setupTracking(root) {
    if (document.documentElement.dataset.spdSellTracking) return;
    document.documentElement.dataset.spdSellTracking = '1';

    document.addEventListener('click', function (e) {
      var a = e.target.closest('.spd-sell a[href]');
      if (!a) return;
      var href = a.getAttribute('href') || '';
      var type = /^tel:/.test(href) ? 'phone' : /^mailto:/.test(href) ? 'email' : a.classList.contains('spd-sell-hero__nav-link') ? 'nav'
        : /quote/i.test(href) ? 'quote' : /upload|inventory/i.test(href + ' ' + a.textContent) ? 'upload' : 'link';
      track('sell_cta_click', { cta_type: type, cta_text: a.textContent.replace(/\s+/g, ' ').trim().slice(0, 80), cta_location: where(a) });
    });

    document.addEventListener('spd-sell:video-play', function (e) {
      var d = e.detail || {};
      track('sell_video_play', { video_title: String(d.title || '').replace(/\s+/g, ' ').trim().slice(0, 80), video_location: d.el ? where(d.el) : '' });
    });
    document.querySelectorAll('[data-spd-sell-video]').forEach(function (modal) {
      modal.addEventListener('toggle', function (e) {
        if (e.newState !== 'open') return;
        var opener = document.querySelector('[popovertarget="' + modal.id + '"]:not([popovertargetaction="hide"])');
        var title = opener ? (opener.getAttribute('aria-label') || '').replace(/^Play(:| video testimonial from)\s*/i, '') : '';
        track('sell_video_play', { video_title: title.slice(0, 80), video_location: where(modal) });
      });
    });

    var cards = [].slice.call(document.querySelectorAll('.spd-sell-formcard'));
    function cardName(card) { return card.closest('.spd-sell-hero') ? 'hero' : 'bottom'; }
    if ('IntersectionObserver' in window) {
      var seen = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          if (!en.isIntersecting) return;
          seen.unobserve(en.target);
          track('sell_form_view', { form_location: cardName(en.target) });
        });
      }, { threshold: 0.4 });
      cards.forEach(function (c) { seen.observe(c); });
    }
    // A click into the cross-origin form iframe moves focus out of this window.
    var started = false;
    window.addEventListener('blur', function () {
      setTimeout(function () {
        var el = document.activeElement;
        if (started || !el || el.tagName !== 'IFRAME') return;
        var card = el.closest('.spd-sell-formcard');
        if (!card) return;
        started = true;
        track('sell_form_start', { form_location: cardName(card) });
      }, 0);
    });
  }

  function init(root) {
    setupAccordions(root);
    setupDrawers(root);
    setupGalleries(root);
    setupVideos(root);
    setupTracking(root);
    mirrorForms(root);
    setupRail(root);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); });
  } else {
    init(document);
  }
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
